import clickWrap from "@js/helpers/click_wrap.js";

const ModalHeader = (props) => {

  return props.children ? (
    <div className="modal-header">
      <button type="button" className="close" onClick={ clickWrap(props.onCancel) }>
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 className="text-left modal-title">{ props.children }</h4>
    </div>
  ) : (
    null
  );

};

export default ModalHeader;
